import type { Control } from "react-hook-form";
import { FormAccordionSection } from "Components/Shared/FormAccordionSection";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import type { FacilityFormModel } from "Components/Shared/Merchant/Facilities/schema";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.Facilities.Form;

type Props = {
  control: Control<FacilityFormModel>;
  isExpanded: boolean;
  onToggle: () => void;
  onNext: () => void;
  isComplete: boolean | undefined;
  hasErrors: boolean;
};

export const BasicInformationSection = ({
  control,
  isExpanded,
  onToggle,
  onNext,
  isComplete,
  hasErrors,
}: Props) => {
  const { t } = useResource();

  return (
    <FormAccordionSection
      legend={t(RESOURCES.Legend.BasicInformation)}
      isExpanded={isExpanded}
      onToggle={onToggle}
      onNext={onNext}
      isComplete={isComplete}
      hasErrors={hasErrors}
    >
      <FormInput
        control={control}
        name="name"
        label={t(RESOURCES.Fields.Name)}
      />
      <FormInput
        control={control}
        name="providedServices"
        label={t(RESOURCES.Fields.ProvidedServices)}
      />
    </FormAccordionSection>
  );
};
